const HINTS = [
  { keys: "↑↓", label: "navigate" },
  { keys: "↵", label: "select" },
  { keys: "esc", label: "close" },
] as const;

export function CommandPaletteFooter() {
  return (
    <div className="flex items-center gap-4 border-t px-5 py-2">
      {HINTS.map(({ keys, label }) => (
        <div
          key={keys}
          className="text-action-disabled-content flex items-center gap-1"
        >
          <kbd className="text-typography-label typo-info bg-surface-raised rounded border px-1 py-px">
            {keys}
          </kbd>
          <span className="typo-body-xs">{label}</span>
        </div>
      ))}
    </div>
  );
}
